import script from "./BulkEditCoreFieldsHub.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditCoreFieldsHub.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditCoreFieldsHub.vue?vue&type=style&index=0&id=42d56db8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d56db8"]])

export default __exports__